import { createSlice } from '@reduxjs/toolkit'
import { ResponseDataBody } from 'src/types/websocket'

const initialState: ResponseDataBody.Connection = {
  Connection: false,
}

const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    setConnection(state, action) {
      state.Connection = action.payload
    },
  },
})

export const { setConnection } = connectionSlice.actions

export default connectionSlice.reducer
